import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { usersApi } from '@/services/rest/apiInstances';

export interface IClientsState {
    isPending: boolean;
    isEditClientBankPaymentFeeModalOpen: boolean;
}

const initialState: IClientsState = {
    isPending: false,
    isEditClientBankPaymentFeeModalOpen: false,
};

export const clientsSlice = createSlice({
    name: 'clients',
    initialState,
    reducers: {
        openEditClientBankPaymentFeeModal: (state) => {
            state.isEditClientBankPaymentFeeModalOpen = true;
        },
        closeEditClientBankPaymentFeeModal: (state) => {
            state.isEditClientBankPaymentFeeModalOpen = false;
        },
    },
});

export const { openEditClientBankPaymentFeeModal, closeEditClientBankPaymentFeeModal } =
    clientsSlice.actions;

export default clientsSlice.reducer;
